import React, { useState } from "react";
import "./Experience.css";
import Description from "./Description";

const Experience = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const [hoveredIndex, setHoveredIndex] = useState(null);

    function handleButton(index) {
        setActiveIndex(activeIndex === index ? null : index);
    }

    const experiences = [
        {
            title: "PRL Internship",
            date: "May 2025",
            description: "Worked on a machine learning model to analyse LIBS (Laser Induced Breakdown Spectroscopy) data, focusing on spectral analysis and feature extraction. Developed algorithms to enhance the accuracy of material identification and classification.",
            image: "/image/prl.png",
            tech: " Machine Learning | Numpy | Pandas | Matplotlib | Tensorflow | Sklearn",
        },
        {
            title: "Vice Chairperson at CodeChef-VIT",
            date: "March 2024",
            description: "Played a key role in organizing and managing competitive coding events, ensuring seamless execution and engagement. Mentored juniors in problem-solving strategies and contributed to the development of platform features to enhance the coding experience.",
            image: "/image/codechef.png",
            tech: " React | Shadcn | Zustand | NextJs | Golang fiber",
        }
    ];

    return (
        <div className="experience-container" id="experience">
            <div className="experience-header">
                <h2>Experience</h2>
                <div className="header-underline"></div>
            </div>

            <div className="experience-list">
                {experiences.map((experience, index) => (
                    <div 
                        key={index} 
                        className={`experience-item ${activeIndex === index ? 'active' : ''}`}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <div className="experience-header-box">
                            <div className="experience-content">
                                <div className="experience-title">
                                    <span className="title-marker"></span>
                                    {experience.title}
                                </div>
                                <div className="experience-meta">
                                    <span className="experience-date">{experience.date}</span>
                                    <button 
                                        onClick={() => handleButton(index)} 
                                        className={`expand-button ${hoveredIndex === index ? 'hovered' : ''}`}
                                        aria-label={activeIndex === index ? "Collapse details" : "Expand details"}
                                    >
                                        {activeIndex === index ? "−" : "+"}
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                        <div className={`experience-details ${activeIndex === index ? 'active' : ''}`}>
                            <Description 
                                title={experience.title}
                                content={experience.description} 
                                image={experience.image} 
                                tech={experience.tech}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Experience;